import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "encodablecolor"
    }}>{`@encodable/color`}</h1>
    <p><a parentName="p" {...{
        "href": "https://img.shields.io/npm/v/@encodable/color.svg?style=flat"
      }}><img alt="Version" src="https://img.shields.io/npm/v/@encodable/color.svg?style=flat" /></a>{`
`}<a parentName="p" {...{
        "href": "https://david-dm.org/kristw/encodable?path=packages/encodable-color"
      }}><img alt="David (path)" src="https://img.shields.io/david/kristw/encodable.svg?path=packages%2Fencodable-color&style=flat-square" /></a></p>
    <p>{`Utilities for managing color schemes and color scales.
Built on top of D3.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @encodable/color global-box
`}</code></pre>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { getColorSchemeRegistry } from '@encodable/color';

/* Get color schemes by name */
getColorSchemeRegistry().get(schemeName);
// Get categorical scheme
getColorSchemeRegistry().categorical.get(schemeName);
// Get sequential scheme
getColorSchemeRegistry().sequential.get(schemeName);
// Get diverging scheme
getColorSchemeRegistry().diverging.get(schemeName);

// Register color scheme
getColorSchemeRegistry().register({
  type: 'categorical',
  id: 'my-scheme',
  colors: [...],
});
`}</code></pre>
    <p>{`The library also includes all schemes from `}<inlineCode parentName="p">{`d3-scale-chromatic`}</inlineCode>{` by default.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      